export const AGENT_CONVERSATION_SORT_OPTIONS = {
  RECENT: 'recent',
  TITLE: 'title',
};

export const getConversationId = (conversation = {}) => `${conversation.id || ''}`;

export const getConversationTitle = (conversation = {}) => conversation.title || 'Untitled conversation';

const getConversationTime = (conversation = {}) => {
  const value = conversation.updated_at || conversation.created_at;
  const timestamp = value ? new Date(value).getTime() : 0;
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

export const filterAgentConversations = (conversations = [], searchText = '') => {
  const query = searchText.trim().toLowerCase();
  if (!query) return conversations;

  return conversations.filter((conversation) => getConversationTitle(conversation).toLowerCase().includes(query));
};

export const sortAgentConversations = (conversations = [], sortBy = AGENT_CONVERSATION_SORT_OPTIONS.RECENT) => {
  const sorted = [...conversations];

  if (sortBy === AGENT_CONVERSATION_SORT_OPTIONS.TITLE) {
    return sorted.sort((a, b) => getConversationTitle(a).localeCompare(getConversationTitle(b), undefined, { sensitivity: 'base' }));
  }

  return sorted.sort((a, b) => getConversationTime(b) - getConversationTime(a));
};

export const getVisibleAgentConversations = (conversations = [], searchText = '', sortBy = AGENT_CONVERSATION_SORT_OPTIONS.RECENT) =>
  sortAgentConversations(filterAgentConversations(conversations, searchText), sortBy);

export const toggleConversationSelection = (selectedIds = [], conversationId) => {
  const id = `${conversationId}`;
  if (!id) return selectedIds;

  return selectedIds.includes(id) ? selectedIds.filter((selectedId) => selectedId !== id) : [...selectedIds, id];
};

export const selectVisibleConversations = (selectedIds = [], visibleConversations = []) => {
  const next = new Set(selectedIds);
  visibleConversations.map((conversation) => {
    const id = getConversationId(conversation);
    if (id) next.add(id);
    return id;
  });
  return Array.from(next);
};

export const pruneConversationSelection = (selectedIds = [], conversations = []) => {
  const existingIds = new Set(conversations.map(getConversationId));
  return selectedIds.filter((id) => existingIds.has(`${id}`));
};

export const getVisibleSelectionState = (selectedIds = [], visibleConversations = []) => {
  const visibleIds = visibleConversations.map(getConversationId).filter(Boolean);
  const selectedVisibleCount = visibleIds.filter((id) => selectedIds.includes(id)).length;

  return {
    selectedVisibleCount,
    allVisibleSelected: visibleIds.length > 0 && selectedVisibleCount === visibleIds.length,
    someVisibleSelected: selectedVisibleCount > 0 && selectedVisibleCount < visibleIds.length,
  };
};
